export const CLICK_SIDE_MENU_ITEM =
  'simplecasino/analytics/CLICK_SIDE_MENU_ITEM'
export const ACCEPT_COOKIE_CONSENT =
  'simplecasino/analytics/ACCEPT_COOKIE_CONSENT'
export const OPEN_SIDE_MENU = 'simplecasino/analytics/OPEN_SIDE_MENU'
export const OPEN_WALLET = 'simplecasino/analytics/OPEN_WALLET'
